class Constants {
  static API_URL = "https://medcase.in/medcase-api";
  // static API_URL = "http://localhost:5005";
}

export default Constants;
